import { FC } from 'react';
import { DigitalForms } from '@wetags/digital-forms';
import { Attachment } from '../../../types/form-packet-selector.types';
import AcceptedFile, { AcceptedFileInheritedProps } from './accepted-file/accepted-file.component';
import { containerStyle } from './accepted-files.styles';

export interface AcceptedFilesProps extends AcceptedFileInheritedProps {
  attachments: Attachment[];
}

const AcceptedFiles: FC<AcceptedFilesProps> = ({ attachments, ...otherProps }) => {
  const [isEnhancedFlowEnabled] = DigitalForms.useWetag('send-forms-enhanced-flow');
  const effectiveIsEnhancedFlowEnabled = otherProps.isEnhancedFlowEnabled ?? isEnhancedFlowEnabled;

  if (attachments.length === 0) {
    return null;
  }

  return (
    <div css={containerStyle(effectiveIsEnhancedFlowEnabled)}>
      {attachments.map((attachment) => (
        <AcceptedFile key={attachment.id} attachment={attachment} {...otherProps} />
      ))}
    </div>
  );
};

export default AcceptedFiles;
